var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowinline = function SvgArrowinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 11 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    fillRule: "evenodd",
    d: "M0 .768.807 0 5.5 4.466 10.193 0 11 .768 5.5 6z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowinline;